const applyConfig = (config) => {
  config.settings = {
    ...config.settings,

    siteProperties: {
      ...config.settings.siteProperties,
      siteTitle: undefined,
      siteSubtitle: undefined,
      subsiteParentSiteTitle: undefined,
      parentSiteTitle: 'Regione Emilia-Romagna',
      parentSiteURL: 'https://regione.emilia-romagna.it',
      arLoginUrl: 'https://servizi.comune.camposanto.mo.it/area-personale',
    },
  };

  config.settings.italiaThemeViewsConfig.imagePosition = 'afterHeader'; // possible values: afterHeader, documentBody

  config.settings['volto-gdpr-privacy'].defaultPanelConfig.text.it.description =
    "Questo sito utilizza i cookie tecnici di navigazione e di sessione per garantire un miglior servizio di navigazione del sito, e cookie analitici per raccogliere informazioni sull'uso del sito da parte degli utenti.  Utilizza anche cookie di profilazione dell'utente per fini statistici. Per i cookie di profilazione puoi decidere se abilitarli o meno cliccando sul pulsante 'Impostazioni'. Per saperne di più, su come disabilitare i cookie oppure abilitarne solo alcuni, consulta la nostra <a href='/documenti-e-dati/atti-normativi/privacy-policy/'>Cookie Policy</a>.";

  config.settings['volto-gdpr-privacy'] = {
    ...config.settings['volto-gdpr-privacy'],
    defaultPanelConfig: null,
  };

  return config;
};

export default applyConfig;
